import {useMutation} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type Rating = 'VERY_NEGATIVE' | 'NEGATIVE' | 'POSITIVE' | 'VERY_POSITIVE'

export type FeedbackSubmission = {
  subject?: string
  rating: Rating
  content?: string
}

export function useSubmitFeedbackMutation(endpoint: string) {
  return useMutation<unknown, Error, FeedbackSubmission>({
    mutationFn: async body => {
      const result = await reactFetchJSON(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body,
      })
      const json = await result.json()

      if (result.ok) return json

      const errorMessage = json.error || 'Unknown error occurred'
      throw new Error(errorMessage, {cause: result.status})
    },
  })
}
